export default __webpack_public_path__ + "static/media/dog.7d04e08e.svg";